export function useColor() {
  return (type) => {
    switch (unref(type)?.toLowerCase()) {
      case "active":
      case "approved":
      case "info":
      case "purchase order":
      case "received":
      case "passed":
      case "auctioning in progress":
      case "confirmed":
      case "business":
      case "unpaid":
      case "review":
      case "linked":
      case "not reconciled":
      case "not_reconciled":
      case "bill payment":
        return { color: "info-10", textColor: "info-50" };

      case "processing":
        return {
          color: "info-20",
          textColor: "info-60",
        };

      case "transferring":
        return {
          color: "info-30",
          textColor: "info-80",
        };

      case "transfer_failed":
        return {
          color: "error-20",
          textColor: "error-60",
        };

      case "debit note":
      case "extreme danger":
      case "fatal error":
      case "pod rejected":
      case "rejected":
      case "not filed":
      case "overdue":
        return { color: "error-30", textColor: "error-80" };

      case "completed":
      case "e-way bill":
      case "live":
      case "returns":
      case "success":
      case "filed":
      case "accepted":
      case "paid":
      case "fully reconciled":
      case "fully_reconciled":
        return { color: "success-30", textColor: "success-80" };

      case "positive":
        return { color: "success-30", textColor: "success-80" };

      case "cancelled":
      case "closed":
      case "closed/expired":
      case "credit note":
      case "danger":
      case "error":
      case "expired":
      case "locked":
      case "unsigned":
      case "ignored":
      case "removed":
        return { color: "error-10", textColor: "error-60" };

      case "negative":
        return {
          color: "error-20",
          textColor: "error-80",
        };

      case "kyc":
      case "withdrawal":
      case "in transit":
      case "initiated":
      case "partially_signed":
      case "pending approval":
        return {
          color: "warning-10",
          textColor: "warning-60",
        };

      case "pod pending":
      case "proof of delivery":
      case "pod":
      case "received with returns":
      case "submitted":
      case "void":
      case "warning":
      case "zero":
      case "e-invoice":
      case "invoice":
      case "in progress":
      case "partially fulfilled":
      case "partially rejected":
      case "processed":
      case "incomplete":
      case "awaiting_response":
      case "in_progress":
        return {
          color: "warning-20",
          textColor: "warning-70",
        };

      case "partially approved":
        return {
          color: "warning-20",
          textColor: "warning-80",
        };

      case "partially paid":
      case "partially reconciled":
      case "partially_reconciled":
        return {
          color: "success-10",
          textColor: "success-50",
        };

      case "pod received":
      case "ready to auction":
      case "enabled":
      case "deposit":
      case "partially closed":
      case "finance":
      case "advance":
        return { color: "success-10", textColor: "success-60" };

      case "below expectations":
        return { color: "success-20", textColor: "success-70" };

      case "disabled":
        return { color: "neutral-10", textColor: "neutral-60" };

      case "awaiting_approval":
      case "gst exempted":
      case "taxable":
      case "signed":
      case "unlinked":
      case "manual":
        return { color: "neutral-40", textColor: "neutral-80" };

      case "skipped":
      case "hold":
        return { color: "neutral-80", textColor: "neutral-10" };

      default:
        return { color: "neutral-20", textColor: "neutral-80" };
    }
  };
}
